import React, { useState } from "react";
import {
    Box,
    Typography,
    Grid,
    TextField,
    Button
} from "@mui/material";
import Select from "react-select";
import { RestartAlt } from "@mui/icons-material";
import { LuRefreshCcw } from "react-icons/lu";


// Example options (replace with dynamic if needed)
const crops = ["Maize", "Rice", "Wheat", "Soyabean", "Chana"];
const models = ["Monte-Carlo (Normal distribution)", "Historical Simulation"];
const outlooks = ["High", "Medium", "Low"];

const toOptions = (arr) => arr.map((val) => ({ label: val, value: val }));

const PortfolioRiskSidebar = () => {
    const [cropSelections, setCropSelections] = useState(Array(5).fill(null));
    const [allocations, setAllocations] = useState(Array(5).fill(""));
    const [selectedModel, setSelectedModel] = useState(null);
    const [selectedOutlook, setSelectedOutlook] = useState(null);

    const handleReset = () => {
        setCropSelections(Array(5).fill(null));
        setAllocations(Array(5).fill(""));
        setSelectedModel(null);
        setSelectedOutlook(null);
    };

    return (
        <Box sx={{ p: 2, width: "100%", maxWidth: 300 }}>
            {/* Crop Title */}
             <h2 className="select-label">Crop</h2>
            {/* Crop Inputs */}
            <Grid container spacing={1}>
                {[0, 1, 2, 3, 4].map((i) => (
                    <React.Fragment key={i}>
                        <Grid item xs={6}>
                            <div className="download-container">

                                <Select
                                    className="custom-select"
                                    placeholder="Select"
                                    value={cropSelections[i]}
                                    onChange={(selected) => {
                                        const updated = [...cropSelections];
                                        updated[i] = selected;
                                        setCropSelections(updated);
                                    }}
                                    options={toOptions(crops)}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                size="small"
                                type="number"
                                placeholder="Type"
                                value={allocations[i]}
                                onChange={(e) => {
                                    const updated = [...allocations];
                                    updated[i] = e.target.value;
                                    setAllocations(updated);
                                }}
                                fullWidth
                            />
                        </Grid>
                    </React.Fragment>
                ))}
            </Grid>

            {/* Model */}
            <Box mt={3}>
                <h2 className="select-label">Model</h2>
                <div className="download-container">
                    <Select
                        className="custom-select"
                        placeholder="Select"
                        value={selectedModel}
                        onChange={(selected) => setSelectedModel(selected)}
                        options={toOptions(models)}
                    />
                </div>
            </Box>

            {/* Forward Outlook */}
            <Box mt={3}>
                <h2 className="select-label">Forward Outlook</h2>
                <div className="download-container">
                    <Select
                        className="custom-select"
                        placeholder="Select"
                        value={selectedOutlook}
                        onChange={(selected) => setSelectedOutlook(selected)}
                        options={toOptions(outlooks)}
                    />
                </div>
            </Box>

            {/* Buttons */}
            <Box mt={4}>
                <Button
                    variant="contained"
                    fullWidth
                    sx={{
                        backgroundColor: "#0880EA",
                        color: "#fff",
                        
                        mb: 1,
                    }}
                >
                    Generate
                </Button>
                <div className="resetbutton"onClick={handleReset}>
                            <LuRefreshCcw style={{ marginRight: "10px" }} />
                            Reset selections
                          </div>
            </Box>
        </Box>
    );
};

export default PortfolioRiskSidebar;
